module.exports = __webpack_public_path__ + "assets/webgl/LM.1.8066634b.jpg";